// @ts-nocheck

import MainDispatcher from '../support/MainDispatcher';
import dash_api from '../support/dash_api';
import server from '../support/server';
import { getCookie, pathIsRelative } from '../support/utils';

function loading() {
  MainDispatcher.dispatch({ action: 'LOGGEDOUT_LOADING' });
}

function foundError(err) {
  MainDispatcher.dispatch({
    action: 'LOGGEDOUT_ERROR',
    error: err,
  });
}

function foundErrorForResetPassword({ response: err = {} }) {
  // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
  if (err.statusText == 'Too Many Requests') {
    MainDispatcher.dispatch({
      action: 'RATE_LIMIT_ERROR',
      error: err,
    });
    // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
  } else if (err.status == 500) {
    MainDispatcher.dispatch({
      action: 'SERVER_ERROR',
      error: err,
    });
  } else {
    MainDispatcher.dispatch({
      action: 'LOGGEDOUT_ERROR',
      error: err,
    });
  }
}

function handleVerificationError({ response: err = {} }) {
  // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
  if (err.status == 400 && err.data == 'Expired Link') {
    MainDispatcher.dispatch({
      action: 'EXPIRED_LINK',
      error: err,
    });
    // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
  } else if (err.statusText == 'Too Many Requests') {
    MainDispatcher.dispatch({
      action: 'RATE_LIMIT_ERROR',
      error: err,
    });
    // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
  } else if (err.status == 500) {
    MainDispatcher.dispatch({
      action: 'SERVER_ERROR',
      error: err,
    });
  }
}

export default {
  login: function (email, password, next_path = false) {
    loading();
    server('loggedout/login', { email: email, password: password })
      .then(function (response) {
        // if response is a url, the user should be on sso subdomain. Redirect
        if (typeof response === 'string' && response.indexOf('http') !== -1) {
          location = response;
          return;
        }

        // CORE-345 Verify Email
        // Make sure that the user views walkthrough after email verification
        if (!response.viewed_walkthrough) {
          next_path = '/start';
        }

        setTimeout(function () {
          if (next_path) {
            next_path = pathIsRelative(next_path) ? next_path : '/'; // Make sure the next_path is a relative path
            window.location = next_path;
          } else {
            window.location = pathIsRelative(window.original_url) ? window.original_url : '/'; // Make sure the window.original.url is a relative path
          }
        }, 250);
      })
      .catch(foundError);
  },
  signup: function (appInfo) {
    appInfo.initial_referrer = getCookie('dashboard_external_referrer');
    appInfo.refId = getCookie('_brefid');
    appInfo.bmp = getCookie('bmp');
    loading();
    return server('loggedout/signup', appInfo)
      .then(function (response) {
        // if response is a url, the user should be on sso subdomain. Redirect
        if (typeof response === 'string' && response.indexOf('http') !== -1) {
          location = response;
          return;
        }
        localStorage.setItem('accept_invite_user_email', appInfo.email);
        window.location.pathname = '/accept-email-invite';
      })
      .catch(foundError);
  },
  sendResetEmail: function (email) {
    loading();
    return dash_api
      .post('password-reset', { email: email })
      .then(function (response) {
        // SSO Flow: if response is a url then redirect user.
        if (typeof response === 'string' && response.indexOf('http') !== -1) {
          location = response;
          return;
        }
        MainDispatcher.dispatch({
          action: 'RESET_EMAIL_SENT',
          user_id: response,
        });
      })
      .catch(foundErrorForResetPassword);
  },
  checkPasswordKey: function (key, type) {
    loading();

    MainDispatcher.dispatch({ action: 'PASSWORD_KEY_LOADING', key: key });

    server('loggedout/check password key', { key, type }).then(
      function () {
        MainDispatcher.dispatch({ action: 'PASSWORD_KEY_VALID', key: key });
      },
      function () {
        MainDispatcher.dispatch({ action: 'PASSWORD_KEY_INVALID', key: key });
      }
    );
  },
  verifyUserEmail: function (token) {
    loading();

    MainDispatcher.dispatch({
      action: 'EMAIL_VERIFICATION_IN_PROGRESS',
      token: token,
    });

    dash_api
      .post('verification-emails/verify', { token })
      .then(function (response) {
        // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
        if (response.status == 200 && response.data.verified == true) {
          MainDispatcher.dispatch({
            action: 'EMAIL_VERIFICATION_SUCCESSFUL',
            token: token,
          });
        } else {
          MainDispatcher.dispatch({
            action: 'EMAIL_VERIFICATION_FAILED',
            token: token,
          });
        }
      })
      .catch(handleVerificationError);
  },
  resendVerificationEmail: function (email) {
    loading();
    return dash_api
      .post('verification-emails/resend', { email: email })
      .then(function (response) {
        // SSO Flow: if response is a url then redirect user.
        if (typeof response === 'string' && response.indexOf('http') !== -1) {
          location = response;
          return;
        }
        MainDispatcher.dispatch({
          action: 'VERIFICATION_EMAIL_SENT',
          user_id: response,
        });
      })
      .catch(handleVerificationError);
  },
  setPassword: function (data, next_path) {
    loading();
    server('loggedout/set password', { ...data }).then(
      function () {
        MainDispatcher.dispatch({
          action: 'SET_PASSWORD_SUCCESS',
        });
        setTimeout(function () {
          if (next_path) {
            next_path = pathIsRelative(next_path) ? next_path : '/'; // Make sure the next_path is a relative path
          } else {
            next_path = '/';
          }
          window.location = next_path;
        }, 250);
      },
      function (err) {
        foundError(err);
      }
    );
  },
  clearErrors: function () {
    Promise.all([
      async () =>
        MainDispatcher.dispatch({
          action: 'CLEAR_ERRORS',
        }),
    ]);
  },
};
